import { render } from "./AddModal.vue?vue&type=template&id=0cfdb037&scoped=true"
import script from "./AddModal.vue?vue&type=script&lang=js"
export * from "./AddModal.vue?vue&type=script&lang=js"

import "./AddModal.vue?vue&type=style&index=0&id=0cfdb037&lang=less&scoped=true"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfdb037"]])

export default __exports__